export class LocationSchema {
  type: string;
  coordinates: number[];

  constructor(latitude = 0, longitude = 0) {
    this.type = 'Point';
    this.coordinates = [longitude, latitude];
  }
}
